import {BarLabels} from '../components/BarChart';

export const FDC_LABELS: BarLabels = {
    uoa: 'La mia Fondazione',
    group: 'Media del mio gruppo',
    average: 'Media di tutte le Fondazioni',
};

export const GROUP_RANGES: {[group: number]: string} = {
    1: '0-25%',
    2: '25-50%',
    3: '50-75%',
    4: '75-100%',
};
